// tslint:disable
/**
 * Agent manager api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Agent } from '../models';
import { AgentList } from '../models';
import { BillList } from '../models';
import { PaymentList } from '../models';
/**
 * AgentApi - axios parameter creator
 * @export
 */
export const AgentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {string} [agentId] 
         * @param {string} [responsibleId] 
         * @param {string} [contractorId] 
         * @param {boolean} [paid] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'formedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentBills(companyId: string, agentId?: string, responsibleId?: string, contractorId?: string, paid?: boolean, offset?: number, limit?: number, sort?: 'createdAt' | 'formedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling agentBills.');
            }
            const localVarPath = `/agent/bills`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }

            if (responsibleId !== undefined) {
                localVarQueryParameter['responsibleId'] = responsibleId;
            }

            if (contractorId !== undefined) {
                localVarQueryParameter['contractorId'] = contractorId;
            }

            if (paid !== undefined) {
                localVarQueryParameter['paid'] = paid;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} [agentId] 
         * @param {string} [responsibleId] 
         * @param {string} [contractorId] 
         * @param {boolean} [paidToAgent] 
         * @param {Date} [paymentAtMin] 
         * @param {Date} [paymentAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'paymentAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentPayments(companyId: string, agentId?: string, responsibleId?: string, contractorId?: string, paidToAgent?: boolean, paymentAtMin?: Date, paymentAtMax?: Date, offset?: number, limit?: number, sort?: 'createdAt' | 'paymentAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling agentPayments.');
            }
            const localVarPath = `/agent/payments`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }

            if (responsibleId !== undefined) {
                localVarQueryParameter['responsibleId'] = responsibleId;
            }

            if (contractorId !== undefined) {
                localVarQueryParameter['contractorId'] = contractorId;
            }

            if (paidToAgent !== undefined) {
                localVarQueryParameter['paidToAgent'] = paidToAgent;
            }

            if (paymentAtMin !== undefined) {
                localVarQueryParameter['paymentAtMin'] = (paymentAtMin as any).toISOString();
            }

            if (paymentAtMax !== undefined) {
                localVarQueryParameter['paymentAtMax'] = (paymentAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Agent} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent(body: Agent, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAgent.');
            }
            const localVarPath = `/agent`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAgent.');
            }
            const localVarPath = `/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Agent} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAgent(id: string, body: Agent, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAgent.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAgent.');
            }
            const localVarPath = `/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAgent.');
            }
            const localVarPath = `/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [middleName] 
         * @param {Array<string>} [conditionsIds] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgent(ids?: Array<string>, companyId?: string, firstName?: string, lastName?: string, middleName?: string, conditionsIds?: Array<string>, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            const localVarPath = `/agents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }

            if (middleName !== undefined) {
                localVarQueryParameter['middleName'] = middleName;
            }

            if (conditionsIds) {
                localVarQueryParameter['conditionsIds'] = conditionsIds.join(COLLECTION_FORMATS.csv);
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentApi - functional programming interface
 * @export
 */
export const AgentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {string} [agentId] 
         * @param {string} [responsibleId] 
         * @param {string} [contractorId] 
         * @param {boolean} [paid] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'formedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentBills(companyId: string, agentId?: string, responsibleId?: string, contractorId?: string, paid?: boolean, offset?: number, limit?: number, sort?: 'createdAt' | 'formedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillList> {
            const localVarAxiosArgs = AgentApiAxiosParamCreator(configuration).agentBills(companyId, agentId, responsibleId, contractorId, paid, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} [agentId] 
         * @param {string} [responsibleId] 
         * @param {string} [contractorId] 
         * @param {boolean} [paidToAgent] 
         * @param {Date} [paymentAtMin] 
         * @param {Date} [paymentAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'paymentAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentPayments(companyId: string, agentId?: string, responsibleId?: string, contractorId?: string, paidToAgent?: boolean, paymentAtMin?: Date, paymentAtMax?: Date, offset?: number, limit?: number, sort?: 'createdAt' | 'paymentAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentList> {
            const localVarAxiosArgs = AgentApiAxiosParamCreator(configuration).agentPayments(companyId, agentId, responsibleId, contractorId, paidToAgent, paymentAtMin, paymentAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Agent} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent(body: Agent, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agent> {
            const localVarAxiosArgs = AgentApiAxiosParamCreator(configuration).createAgent(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AgentApiAxiosParamCreator(configuration).deleteAgent(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Agent} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAgent(id: string, body: Agent, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agent> {
            const localVarAxiosArgs = AgentApiAxiosParamCreator(configuration).editAgent(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agent> {
            const localVarAxiosArgs = AgentApiAxiosParamCreator(configuration).getAgent(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [middleName] 
         * @param {Array<string>} [conditionsIds] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgent(ids?: Array<string>, companyId?: string, firstName?: string, lastName?: string, middleName?: string, conditionsIds?: Array<string>, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentList> {
            const localVarAxiosArgs = AgentApiAxiosParamCreator(configuration).listAgent(ids, companyId, firstName, lastName, middleName, conditionsIds, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentApi - factory interface
 * @export
 */
export const AgentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} companyId 
         * @param {string} [agentId] 
         * @param {string} [responsibleId] 
         * @param {string} [contractorId] 
         * @param {boolean} [paid] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'formedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentBills(companyId: string, agentId?: string, responsibleId?: string, contractorId?: string, paid?: boolean, offset?: number, limit?: number, sort?: 'createdAt' | 'formedAt', order?: 'ASC' | 'DESC', options?: any) {
            return AgentApiFp(configuration).agentBills(companyId, agentId, responsibleId, contractorId, paid, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {string} [agentId] 
         * @param {string} [responsibleId] 
         * @param {string} [contractorId] 
         * @param {boolean} [paidToAgent] 
         * @param {Date} [paymentAtMin] 
         * @param {Date} [paymentAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'paymentAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentPayments(companyId: string, agentId?: string, responsibleId?: string, contractorId?: string, paidToAgent?: boolean, paymentAtMin?: Date, paymentAtMax?: Date, offset?: number, limit?: number, sort?: 'createdAt' | 'paymentAt', order?: 'ASC' | 'DESC', options?: any) {
            return AgentApiFp(configuration).agentPayments(companyId, agentId, responsibleId, contractorId, paidToAgent, paymentAtMin, paymentAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @param {Agent} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent(body: Agent, options?: any) {
            return AgentApiFp(configuration).createAgent(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent(id: string, options?: any) {
            return AgentApiFp(configuration).deleteAgent(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Agent} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAgent(id: string, body: Agent, options?: any) {
            return AgentApiFp(configuration).editAgent(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent(id: string, options?: any) {
            return AgentApiFp(configuration).getAgent(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [middleName] 
         * @param {Array<string>} [conditionsIds] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgent(ids?: Array<string>, companyId?: string, firstName?: string, lastName?: string, middleName?: string, conditionsIds?: Array<string>, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
            return AgentApiFp(configuration).listAgent(ids, companyId, firstName, lastName, middleName, conditionsIds, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
    };
};

/**
 * AgentApi - object-oriented interface
 * @export
 * @class AgentApi
 * @extends {BaseAPI}
 */
export class AgentApi extends BaseAPI {
    /**
     * 
     * @param {string} companyId 
     * @param {string} [agentId] 
     * @param {string} [responsibleId] 
     * @param {string} [contractorId] 
     * @param {boolean} [paid] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'createdAt' | 'formedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public agentBills(companyId: string, agentId?: string, responsibleId?: string, contractorId?: string, paid?: boolean, offset?: number, limit?: number, sort?: 'createdAt' | 'formedAt', order?: 'ASC' | 'DESC', options?: any) {
        return AgentApiFp(this.configuration).agentBills(companyId, agentId, responsibleId, contractorId, paid, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} companyId 
     * @param {string} [agentId] 
     * @param {string} [responsibleId] 
     * @param {string} [contractorId] 
     * @param {boolean} [paidToAgent] 
     * @param {Date} [paymentAtMin] 
     * @param {Date} [paymentAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'createdAt' | 'paymentAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public agentPayments(companyId: string, agentId?: string, responsibleId?: string, contractorId?: string, paidToAgent?: boolean, paymentAtMin?: Date, paymentAtMax?: Date, offset?: number, limit?: number, sort?: 'createdAt' | 'paymentAt', order?: 'ASC' | 'DESC', options?: any) {
        return AgentApiFp(this.configuration).agentPayments(companyId, agentId, responsibleId, contractorId, paidToAgent, paymentAtMin, paymentAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Agent} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public createAgent(body: Agent, options?: any) {
        return AgentApiFp(this.configuration).createAgent(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public deleteAgent(id: string, options?: any) {
        return AgentApiFp(this.configuration).deleteAgent(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {Agent} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public editAgent(id: string, body: Agent, options?: any) {
        return AgentApiFp(this.configuration).editAgent(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public getAgent(id: string, options?: any) {
        return AgentApiFp(this.configuration).getAgent(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {string} [companyId] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {string} [middleName] 
     * @param {Array<string>} [conditionsIds] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'createdAt' | 'updatedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public listAgent(ids?: Array<string>, companyId?: string, firstName?: string, lastName?: string, middleName?: string, conditionsIds?: Array<string>, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
        return AgentApiFp(this.configuration).listAgent(ids, companyId, firstName, lastName, middleName, conditionsIds, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

}
